import { useEffect, useMemo, useState } from "react";
import { getBusinessConfigs, getMe } from "../utils/bridges/methods";
import dayjs from "dayjs";

export default function useCanShowOnboardingChange() {
  const [disableOnboardFlow, setDisableOnboardFlow] = useState(true);

  useEffect(() => {
    const fetchBizSettings = async () => {
      const bizSettings = await getBusinessConfigs();
      setDisableOnboardFlow(bizSettings?.disableOnboardFlow || false);
    };
    fetchBizSettings();
  }, []);

  const me = useMemo(() => getMe(), []);
  const isUserCreatedLessThan30Days = useMemo(() => {
    return me?.user_meta?.createdAt
      ? dayjs(me?.user_meta?.createdAt).isAfter(dayjs().subtract(30, "days"))
      : false;
  }, [me?.user_meta?.createdAt]);

  const canShowOnboardingChange = useMemo(() => {
    return isUserCreatedLessThan30Days && !disableOnboardFlow;
  }, [isUserCreatedLessThan30Days, disableOnboardFlow]);

  return canShowOnboardingChange;
}
